module.exports = __webpack_public_path__ + "static/chiranjeev-kumar-fa9b37d106fac8e4dc6bde021332a2a3.jpg";